import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getCookie } from "src/utils/cookieUtil";
import { baseQueryWithIntercept } from "src/utils/rtkQueryBaseQueryUtil";
import { SkuVo } from "src/vo/skuVo";

const serverIp = process.env.REACT_APP_SERVER_IP;

// 1-1. initial state 객체 생성
const initialState: SkuVo = {};

export const skuAPI = createApi({
  baseQuery: baseQueryWithIntercept,
  refetchOnMountOrArgChange: true,
  reducerPath: "skuAPI",
  endpoints: (builder) => ({
    // SKU 요약 조회
    skuRate: builder.query({
      query: ({ shop_code, brand_code }) => ({
        url: `sku/sku-rate/${shop_code}/${brand_code}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
      }),
    }),
    // SKU 상세 조회
    skuDetail: builder.query({
      query: ({ erpCode, ...data }) => ({
        url: `sku/sku-detail/${erpCode}`,
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "*/*, text/plain",
        },
        params: { data: JSON.stringify(data) },
      }),
    }),
  }),
});

export const { useSkuRateQuery, useSkuDetailQuery } = skuAPI;
